import babelpolyfill   from 'babel-polyfill'
import Vue             from 'vue'
import App             from './App'
import ElementUI       from 'element-ui'
import './assets/theme/element-theme-chalk/index.css'
import VueRouter       from 'vue-router'
import routes          from './routes'
import util            from './common/AppUtil'
import axios from 'axios';

import VueGoogleCharts from 'vue-google-charts'
import wysiwyg         from 'vue-wysiwyg'    /* WYSIWYG */
import 'vue-wysiwyg/dist/vueWysiwyg.css'   /* WYSIWYG */

Vue.use(wysiwyg, {			                   /* WYSIWYG */
    hideModules: { "code": true, "table":  true},
     maxHeight: "150px"
}); 

Vue.use(ElementUI)
Vue.use(VueRouter)
Vue.use(VueGoogleCharts)

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  
  if (to.path == '/login') {
    window.sessionStorage.removeItem('token');
    window.sessionStorage.removeItem('user');
  }

  let user = window.sessionStorage.getItem('token');
  if (!user && (to.path != '/login' && to.path != '/changepassword' )) {
    next({ path: '/login' })
  }
  else {
    next()
  }
  // NO AUTH? COMMENT ABOVE AND UNCOMMENT UNDER.  
  //next()
})



const app = new Vue({
  router,
  created: function() {
  },
  render: h => h(App)        
 }).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js